import angular from 'angular'
import forEach from 'lodash/forEach'

import MultiselectPopoverContentController from './vd-multiselect-popover-content.controller'
import popoverTemplate from './vd-multiselect-popover-content.html'

/**
 * Controller for the vd-multiselect-popover component.
 *
 * @class MultiselectPopoverController
 */
export default class MultiselectPopoverController {
  constructor($scope, $element, $attrs, vdPopover) {
    'ngInject'

    this._$scope = $scope
    this._$element = $element
    this._$attrs = $attrs
    this._vdPopover = vdPopover
    this._popoverHasBeenOpened
    this._popoverIsOpen
  }

  $onInit() {
    this.ngModelCtrl.$isEmpty = value => {
      return !value || value.length === 0
    }
  }

  $postLink() {
    this._$attrs.$addClass(
      'vd-select-container vd-multiselect-popover-container vd-field--short'
    )
    this._inputElement = angular.element(
      this._$element[0].querySelector('.vd-multiselect-popover-input')
    )

    this._inputElement.on('focus', () => this.ngModelCtrl.$setTouched())
    this._inputElement.on('blur', () => {
      if (this._popoverHasBeenOpened && !this._popoverIsOpen) {
        this._$scope.$applyAsync(() => this.ngModelCtrl.$setDirty())
      }
    })
  }

  /**
   * Get the display value for the input
   *
   * @method getDisplayValue
   *
   * @return {String} A string of selected item names
   */
  getDisplayValue() {
    const displayArray = []

    forEach(this.ngModelCtrl.$modelValue, selectedItem =>
      displayArray.push(selectedItem[this.key])
    )

    return displayArray.join(', ')
  }

  /**
   * Determine if the line lenght was exceeded and return the item count help text
   *
   * @method lineLengthExceededItemCount
   *
   * @return {String} A string representing the item count. An empty string if max length as not been reached,
   *         the item count and count label otherwise. eg. (2 Cities)
   */
  lineLengthExceededItemCount() {
    const elementNode = this._$element[0]
    let display = ''

    if (elementNode.offsetWidth < elementNode.firstChild.scrollWidth) {
      display = `(${this.ngModelCtrl.$modelValue.length} ${this.countLabel})`
    }

    return display
  }

  /**
   * Open the multiselect popover
   *
   * @method showPopover
   *
   * @param {Event} event
   */
  showPopover(event) {
    const selectedItems = this.ngModelCtrl.$modelValue || []
    this._popoverHasBeenOpened = true
    this._popoverIsOpen = true

    this._vdPopover
      .open({
        trigger: event.currentTarget,
        template: popoverTemplate,
        controller: MultiselectPopoverContentController,
        hasPopoverList: true,
        items: this.items,
        key: this.key,
        selectedItems,
        selectAllLabel: this.selectAllLabel,
        onSelect: items => {
          this.ngModelCtrl.$setViewValue([...items])
        },
      })
      .then(popover => {
        popover.closed.then(() =>
          this._$scope.$applyAsync(() => {
            this._popoverIsOpen = false
          })
        )
      })
  }
}
